import { Text } from "@mantine/core";

const PrivacyPolicy = () => {
  return (
    <Text align="left">
      <h1>Privacy Page</h1>
      <p>
        <strong>Last updated: 26 June 2023</strong>
      </p>
      <p>
        This Privacy Policy applies to all users and visitors to the site. We
        are committed to protecting your privacy and handling your personal
        information responsibly. Your privacy is important to us. Scale to Zero
        AWS kit's policy is to respect your privacy and{" "}
        <strong>comply with any applicable law and regulation</strong> regarding
        any information we may collect from you across our website and other
        sites we own and operate.
      </p>
      <p>
        We only ask for personal information when we truly need it.{" "}
        <strong>
          We keep your personal information only for as long as we need to.
        </strong>{" "}
        We don't share any personally identifying information publicly or with
        third parties.
      </p>
      <p>
        We fulfill the roles of a data controller and a data processor regarding
        the personal data handled through Scale to Zero AWS and its associated
        services by relevant data protection laws, including the EU General Data
        Protection Regulation (GDPR).
      </p>
      <p>
        Please note that our website may include links to external sites that
        are not under our operation. We do not have control over the content and
        practices of these sites and, therefore, cannot assume responsibility or
        liability for their privacy policies. They might use cookies, collect
        data, and use the data.
      </p>
      <p>
        By continuing to use our website, you will be considered as agreeing to
        our privacy and personal information policies. If you have any inquiries
        regarding how we manage user data and personal information, please don't
        hesitate to contact us.
      </p>

      <p>
        <a href="mailto:contact@scaletozeroaws.com">
          contact@scaletozeroaws.com
        </a>
      </p>
      <p>This policy is effective as of 21 May 2023.</p>
    </Text>
  );
};

export default PrivacyPolicy;
